<template>
	<div class="info">
		<h2>{{datas.title}}</h2>
		<div class="ifont">
			<span>发布时间：{{datas.publishedTime}}</span>
			<div>
				<span>
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-yuedu-2"></use>
					</svg>
					阅读
					<span>{{datas.readCount?datas.readCount:0}}</span>
				</span>
				<span @click="dianzan()" :class="{'active':hasThumb}" style="cursor: pointer;">
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-dianzan"></use>
					</svg>
					点赞
					<span>{{ThumbNum}}</span>
				</span>
			</div>

		</div>
		<div class="img">
			<img :src="datas.contentThumbnail" alt="">
		</div>
		<div class="content" v-html="datas.content">

		</div>
		<div class="center">
			<el-button type="primary" @click="back()">返回</el-button>
		</div>
	</div>

</template>

<script>
	import {
		queryNewsById,
		addNewReadCount,
		addNewThumb
	} from "@/api/msg/msg";
	export default {
		name: "title",
		data() {
			return {
				datas: '',
				hasThumb:'',
				ThumbNum:''
				// dialogheaderVisible:false,
			}
		},
		created() {
			let id = this.$route.query.id;
			addNewReadCount(id);
			queryNewsById(id).then(res => {
				this.datas = res.data.data;
				this.hasThumb = (this.datas.hasThumb=='00901')?true:false;
				this.ThumbNum = this.datas.thumbs?this.datas.thumbs:0
			})
			

		},
		methods: {
			back() {
				this.$router.go(-1);
			},
			dianzan(){
				let id = this.$route.query.id;
				addNewThumb(id).then(res => {
					if(res.data.code=='0'){
						if(this.hasThumb){
							this.ThumbNum = this.ThumbNum*1 - 1;
						}else{
							this.ThumbNum = this.ThumbNum*1 + 1;
						}
						this.hasThumb = !this.hasThumb;
					}
				})
			}
		}
	};
</script>

<style scoped>
	.info h2 {
		line-height: 62px;
		font-weight: normal;
		font-size: 24px;
		color: #333333;
	}

	.ifont {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.ifont>span {
		color: #9fa3a7;
		font-size: 14px;
		line-height: 30px;
	}

	.ifont>div .icon,
	.ifont>div span {
		font-size: 12px;
		color: #666666;

	}
	
		.ifont>div .active .icon,
	.ifont>div span.active,.ifont>div span.active span {
		color: #f06c31;
		}
	.ifont>div .icon {
		margin-left: 15px;
		line-height: 30px;
	}

	.img>img {
		width: 100%;
		display: block;
		margin-bottom: 20px;
	}

	.content>>>img {
		width: 100%;
		display: block;
		margin-bottom: 20px;
	}
</style>
